import React, { useEffect, useState } from 'react';
import { applyServiceWorkerUpdate } from '../serviceWorkerRegistration';

/**
 * Non-blocking banner that appears at the bottom of the screen when a new
 * version of Lauft Pro has been downloaded by the service worker and is
 * waiting to take over. Tapping "Refresh" activates it and reloads.
 *
 * Drop this anywhere in your component tree (probably right under <Router>
 * in App.js) and it'll listen for the update event automatically.
 */
const PWAUpdateBanner = () => {
  const [updateReady, setUpdateReady] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const handler = () => setUpdateReady(true);
    window.addEventListener('lauftpro-sw-update-ready', handler);
    return () => window.removeEventListener('lauftpro-sw-update-ready', handler);
  }, []);

  if (!updateReady || dismissed) return null;

  const handleRefresh = () => {
    applyServiceWorkerUpdate();
    // The page will reload automatically via the controllerchange listener
  };

  const handleDismiss = () => {
    setDismissed(true);
    // The waiting worker stays waiting — they'll see the banner again next session
  };

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 16,
        left: 16,
        right: 16,
        maxWidth: 480,
        margin: '0 auto',
        backgroundColor: '#000000',
        color: '#ffffff',
        borderRadius: 12,
        padding: '14px 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 12,
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.32)',
        zIndex: 99999,
        fontSize: 14,
        fontFamily: 'inherit',
      }}
      role="status"
      aria-live="polite"
    >
      <div style={{ flex: 1, lineHeight: 1.4 }}>
        <div style={{ fontWeight: 600, marginBottom: 2 }}>
          New version available
        </div>
        <div style={{ opacity: 0.75, fontSize: 13 }}>
          Refresh to get the latest update
        </div>
      </div>
      <div style={{ display: 'flex', gap: 8, flexShrink: 0 }}>
        <button
          onClick={handleDismiss}
          style={{
            background: 'transparent',
            border: 'none',
            color: 'rgba(255,255,255,0.6)',
            padding: '8px 10px',
            borderRadius: 8,
            cursor: 'pointer',
            fontSize: 13,
          }}
          aria-label="Dismiss update notification"
        >
          Later
        </button>
        <button
          onClick={handleRefresh}
          style={{
            background: '#FFD700',
            border: 'none',
            color: '#000000',
            padding: '8px 14px',
            borderRadius: 8,
            cursor: 'pointer',
            fontSize: 13,
            fontWeight: 600,
          }}
        >
          Refresh
        </button>
      </div>
    </div>
  );
};

export default PWAUpdateBanner;